module.exports = __webpack_public_path__ + "static/media/mikko-kojon-product-director-sympa-oy-vinkit-hajautetun-ohjelmistokehitystiimin-kayttoon.530b0d46.jpg";